









// Copyright © 2021 Move Closer

import { defineComponent, getCurrentInstance } from '@vue/composition-api'

import { BootstrapIconProps } from './Icon.contracts'
import { bootstrapIconProps, useBootstrapIcon } from './Icon.hooks'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
export const BootstrapIcon = defineComponent({
  name: 'BootstrapIcon',
  props: bootstrapIconProps,

  setup (props: BootstrapIconProps) {
    const internalInstance = getCurrentInstance()
    const { component, _title } = useBootstrapIcon(props, internalInstance)
    return { component, _title }
  }
})

export default BootstrapIcon
